import { EditAdminDelegateComponent } from './edit-admindelegate/edit-admindelegate.component';
import { AddAdminDelegateComponent } from './add-admindelegate/add-admindelegate.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListAdminDelegateComponent } from './list-admindelegate/list-admindelegate.component';

export const routesAdminDelegate: Routes = [
    { path: 'page-admindelegate', component: ListAdminDelegateComponent },
    { path: 'page-admindelegate/add', component: AddAdminDelegateComponent },
    { path: 'page-admindelegate/:id/edit', component: EditAdminDelegateComponent },
];

export const AdminDelegateRoutes: ModuleWithProviders = RouterModule.forChild(routesAdminDelegate);
